/**
 * Gestió de la creació i carrega de capes de tipus social:
 * - L.Wikipedia.custom.js
 * - L.Twitter.custom.js
 */

function addTwitterLayer(){
	
	//$.publish('analyticsEvent',{event:['mapa', tipus_user+'twitter', hashtag, 1]});	
	
	var hashtag = $('#twitter-collapse .input-group #hashtag_twitter_layer').val();
	//Control no afegit #
	if(hashtag.indexOf("#") == 0) hashtag = hashtag.substr(1);
	
	if(hashtag == null || hashtag == "") return;
	
	$('#twitter-collapse .input-group #hashtag_twitter_layer').val("");
	var twitter = new L.Twitter({
		hashtag: hashtag,
		nom: 'twitter #'+ hashtag,
		businessId: '-1',
		tipus: t_xarxes_socials
	});

	//Si el mapa existeix a BD
	if(typeof url('?businessid') == "string"){	
		var order = 0;
		if(controlCapes){
			order = controlCapes._lastZIndex+1;
		}
		var data = {
			uid:Cookies.get('uid'),
			mapBusinessId: url('?businessid'),
			serverName: 'twitter #'+ hashtag,
			serverType: t_xarxes_socials,
			calentas: false,
			activas: true,
			visibilitats: true,
			order: order,
			epsg: '4326',
			transparency: true,
			visibilitat: visibilitat_open,
			options: '{"xarxa_social": "twitter", "hashtag": "'+hashtag+'"}'
		};
		
		createServidorInMap(data).then(function(results){
			if (results.status == "OK"){
				twitter.options.businessId = results.results.businessId;
				twitter.options.xarxa_social="twitter";
				twitter.options.hashtag=hashtag;
				twitter.addTo(map);
				if(controlCapes){
					twitter.options.zIndex = controlCapes._lastZIndex+1;
					controlCapes.addOverlay(twitter, 'twitter #'+ hashtag, true);
					controlCapes._lastZIndex++;
				}
				InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
				if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
					updateSortablesElements();
				}
			}else{
				console.debug('error create server in map');
			}
		});	
	}else{
		twitter.addTo(map);
		if(controlCapes){
			twitter.options.zIndex = controlCapes._lastZIndex+1;
			controlCapes.addOverlay(twitter, 'twitter #'+ hashtag, true);
			controlCapes._lastZIndex++;
		}
		InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
		if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
			updateSortablesElements();
		}
	}	
	//Tanquem input twitter
	$('#twitter-collapse').hide();
} 

function loadTwitterLayer(layer, hashtag){
	var twitter = new L.Twitter({
		hashtag: hashtag,
		nom: layer.serverName,
		tipus : layer.serverType,
		zIndex: parseInt(layer.capesOrdre), 
		businessId: layer.businessId
	});	
	
	var objLayer = {activa: false, layer: null};
	var options = jQuery.parseJSON( layer.options );
	if (options.group){
		twitter.options.group=options.group;
	}
	
	if (true === layer.capesActiva || 'true' === layer.capesActiva ){
		twitter.addTo(map);
		objLayer.activa = true;
	}
	if(controlCapes){
		controlCapes.addOverlay(twitter, layer.serverName, true);
		controlCapes._lastZIndex++;
	}
	objLayer.layer = twitter;
	return objLayer;
}

function addWikipediaLayer(){	
	
	//$.publish('analyticsEvent',{event:['mapa', tipus_user+'wikipedia', 'label wikipedia', 1]});
	
	var keyName = $('#wikipedia-collapse .input-group #name_wikipedia_layer').val();	
	
	var wikipedia = new L.Wikipedia({
		nom : 'wikipedia',
		businessId: '-1',
		tipus: t_xarxes_socials,
		key: keyName
	});
	
	if(typeof url('?businessid') == "string"){
		var order = 0;
		if(controlCapes){
			order = controlCapes._lastZIndex+1;
		}
		var data = {
			uid:Cookies.get('uid'),
			mapBusinessId: url('?businessid'),
			serverName: 'wikipedia',
			serverType: t_xarxes_socials,
			calentas: false,
            activas: true,
            visibilitats: true,
            order: order,
            epsg: '4326',
            transparency: true,
            visibilitat: visibilitat_open,
			options: '{"xarxa_social": "wikipedia", "key": "'+keyName+'"}'
		};
		
		createServidorInMap(data).then(function(results){
			if (results.status == "OK"){
				wikipedia.options.businessId = results.results.businessId;			
				wikipedia.options.xarxa_social = "wikipedia";				
				wikipedia.options.key = keyName;								
				wikipedia.addTo(map);
				if(controlCapes){
					wikipedia.options.zIndex = controlCapes._lastZIndex+1;
					controlCapes.addOverlay(wikipedia, 'wikipedia', true);
					controlCapes._lastZIndex++;
				}
				InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
				if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
					updateSortablesElements();
				}
			}else{
				console.debug('error create server in map');
			}
		});
	}else{
					
		wikipedia.addTo(map);
		if(controlCapes){
			wikipedia.options.zIndex = controlCapes._lastZIndex+1;
			controlCapes.addOverlay(wikipedia, 'wikipedia', true);
			controlCapes._lastZIndex++;
		}
		InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
		if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
			updateSortablesElements();
		}
	}	
}

function loadWikipediaLayer(layer){
	var wikipedia = new L.Wikipedia({
		zIndex: parseInt(layer.capesOrdre),
		nom : layer.serverName,
		tipus : layer.serverType,
		businessId: layer.businessId
	});	
	
	var objLayer = {activa: false, layer: null};
	var options = jQuery.parseJSON( layer.options );
	if (options.group){
		wikipedia.options.group=options.group;
	}
		
	if (true === layer.capesActiva || 'true' === layer.capesActiva){
		wikipedia.addTo(map);
		objLayer.activa = true;
	}
	if(controlCapes){
		controlCapes.addOverlay(wikipedia, layer.serverName, true);
		controlCapes._lastZIndex++;
	}
	objLayer.layer = wikipedia;
	return objLayer;
}
